import { render } from "./FieldSetting.vue?vue&type=template&id=76437c6e"
import script from "./FieldSetting.vue?vue&type=script&lang=js"
export * from "./FieldSetting.vue?vue&type=script&lang=js"
script.render = render

export default script